import { Box, BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

interface PageContainerProps extends BoxProps {}

const PageContainer = styled((props: PageContainerProps) => (
  <Box {...props} />
))(({ theme }) => ({
  padding: theme.spacing(2),
  maxWidth: "100%",
  backgroundColor: "#FFFFFF",
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(3),
  },
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(4),
  },
}));

export default PageContainer; 